import { __extends } from "tslib";
import ABaseNative from './native.base';
var RNNative = /** @class */ (function (_super) {
    __extends(RNNative, _super);
    function RNNative() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RNNative.prototype.getCallHandler = function (target, method) {
        // TODO: 'Method not implemented.'
        return function (callbackId, params) { };
    };
    return RNNative;
}(ABaseNative));
export default RNNative;
